import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import ValidationPage from "@/views/ValidationPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:id',
    name: 'ValidationPage',
    component: ValidationPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
